var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h802v602H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M97.6 50C97.6 23.744 76.256 2.4 50 2.4S2.4 23.744 2.4 50 23.744 97.6 50 97.6 97.6 76.256 97.6 50zm-2.71 0c0 24.732-20.158 44.89-44.89 44.89S5.11 74.732 5.11 50 25.268 5.11 50 5.11 94.89 25.268 94.89 50zM40.683 71.683h19.311V69.31c-4.912-.508-5.251-1.016-5.251-6.437V35.771c-4.065 1.355-8.808 2.371-13.382 2.88v2.202c4.235.677 4.574 1.016 4.574 6.098v15.923c0 5.59-.509 5.929-5.252 6.437v2.372zm14.06-47.092c0-2.88-2.202-5.082-5.082-5.082-2.71 0-5.082 2.202-5.082 5.082 0 2.71 2.372 5.082 5.082 5.082 2.88-.17 5.082-2.372 5.082-5.082z"
  }))));
};
export default SvgInfo;